'use strict';

var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var WEEK = 7 * DAY;
var YEAR = DAY * 365;
var MONTH = YEAR / 12;

var FORMATS = [
    [           MINUTE, 'agora'               ],
    [     MINUTE * 1.5, 'há 1 min'            ],
    [             HOUR, 'min'        , MINUTE ],
    [       1.5 * HOUR, 'há 1 hora'           ],
    [              DAY, 'horas'      , HOUR   ],
    [        1.5 * DAY, 'ontem'               ],
    [          7 * DAY, 'dias'       , DAY    ],
    [       1.5 * WEEK, 'há 1 semana'         ],
    [            MONTH, 'semanas'    , WEEK   ],
    [      1.5 * MONTH, 'há 1 mês'            ],
    [             YEAR, 'meses'      , MONTH  ],
    [       1.5 * YEAR, 'há 1 ano'            ],
    [ Number.MAX_VALUE, 'anos'       , YEAR   ]
];


function convertToDate(date) {
    var converted;

    if (date instanceof Date) converted = date;
    else converted = new Date(date);

    if (isNaN(converted.getTime())) throw new TypeError('Invalid Date');

    return converted;
}


function getDelta(start, end) {
    if (!start) start = (new Date()).getTime();
    else start = convertToDate(start).getTime();
    end = convertToDate(end).getTime();
    return end - start;
}


function humanizedDatetime(delta) {
    var format;
    var output;
    var unit;
    var limit;
    var text;

    for (var i = 0; i < FORMATS.length; i++) {
        format = FORMATS[i];
        limit = format[0];
        if (delta < limit) {
            text = format[1];
            unit = format[2];
            if (unit) output = 'há ' + Math.round(delta / unit) + ' ' + text;
            else output = text;
            return output;
        }
    }
}

module.exports = {
    convertToDate: convertToDate,
    getDelta: getDelta,
    humanizedDatetime: humanizedDatetime
};
